<app-loading-overlay *ngIf="authService.busy">
  <h2 style="color:black;">Loading Little Sis Premium</h2>
</app-loading-overlay>
<div class="splash-panel flex flex-col" fxFlexFill [ngClass]="{'busy': authService.busy}">

  <div class="banner-panel">
    <img src="/assets/images/logos/AIT-CDW_Horizontal_white-01.png" height="110em" alt="CDW Amplified for Education logo">
  </div>

  <div class="login-panel flex flex-row">
    <div fxLayout="column" style="max-width:50%;" fxLayoutAlign="start start">
      <div class="info-text"><b>Little SIS Premium</b> makes Google Classroom management more efficient and effective.
      </div>
      <div class="info-text">Enabling schools to <b>sync SIS classroom roster data with Google Classroom</b> automatically to ensure rosters are maintained, helping teachers and students connect and remain connected.
      </div>
      <div class="login-button-panel"  fxLayout="row" fxLayoutGap="10px" >
        <button class="more-info-button" mat-flat-button (click)="openMore()">LEARN MORE</button>
        <button mat-raised-button color="primary" (click)="login()">LOG IN WITH GOOGLE</button>
      </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="start center" style="width:100%;">
      <img src="/assets/images/logos/LS-Premium_banner_large.png" style="max-width:700px; width:100%;">
    </div>
  </div>

  <div class="marketing-panel" fxLayout="row" fxLayoutAlign="start start">
    <ul>
      <li>Synchronize your Classroom classes and rosters with your SIS data</li>
      <li>Analyze and sync student guardians</li>
      <li>Automate your Roster and Guardian sync jobs for ongoing management;<br/>or simply provision at key dates in the academic year to help your teachers get started with Google Classroom</li>
    </ul>
  </div>

  <div fxFlex class="spacer-panel"></div>
  <div class="footer-panel" fxLayout="row" fxLayoutAlign="end center">
    <div>
      <a class="terms-privacy" href="https://www.cdw.com/content/cdw/en/terms-conditions/privacy-notice/education-privacy-disclosures.html" target="_blank">LEGAL</a>
      <small><em>{{versions.version}} | {{versions.revision}} ({{versions.branch}})</em></small>
    </div>

  </div>

</div>

